<div class="flex bg-white justify-center text-center items-center h-auto md:h-screen pt-20 md:pt-0">
    <div class="flex flex-col px-10 py-8 items-center rounded-3xl shadow max-w-[440px]">
        <img class="pb-6" [src]="assetUrl + 'icons/check-big.svg'" alt="">
        <span class="text-xl text-gray-900 pb-1">We've received your request!</span>
        <span class="text-sm text-gray-600 pb-6">Your team will reach out shortly to help you explore how our platform can support your goals. </span>
        <button class="ml-3 px-6 py-2 shadow rounded-3xl bg-gray-950 text-xs md:text-md text-white whitespace-nowrap">Explore our features</button>
    </div>
</div>
